import useSWR from 'swr'
import fetcher from '../utils/fetcher'

const useImporters = (country, city) => {
    const url = `https://extranet.greentec.eu/api/importers?filter[country_code]=${country}&filter[city]=${city}`
    const {data, error} = useSWR(url, fetcher)

    return {
        importers: data,
        importersLoading: !error && !data,
        importersError: error
    }
}

export default useImporters